export function OutlineLinkIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7972 14.5819L14.4732 11.6151C14.8286 10.9862 15.0015 10.2949 15.0015 9.6132C15.0015 8.23061 14.3004 6.88643 13.0421 6.14713C11.1739 5.04299 8.77264 5.70067 7.69207 7.61133L3.52348 14.9947C3.46104 15.1051 3.40822 15.2155 3.35539 15.326C3.11526 15.8636 3 16.4301 3 16.9966C3 17.2462 3.02401 17.4911 3.07204 17.7311C3.26894 18.84 3.92689 19.8578 4.95943 20.4626C5.99198 21.0723 7.183 21.1443 8.22035 20.7699"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M11.2029 9.41724L9.52681 12.384C9.17143 13.0129 8.99854 13.7042 8.99854 14.3859C8.99854 15.7685 9.6997 17.1127 10.958 17.852C12.8262 18.9561 15.2226 18.2984 16.3032 16.3878L20.4766 9.00439C20.539 8.89397 20.5918 8.78356 20.6447 8.67314C20.8848 8.13547 21.0001 7.56899 21.0001 7.00252C21.0001 6.75288 20.976 6.50805 20.928 6.26802C20.7311 5.15907 20.0732 4.14134 19.0406 3.53645C18.0081 2.92677 16.8171 2.85476 15.7797 3.22921"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
}
